


































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { MinistryMeeting, MinistryMeetingInformation } from '../common/form-type.interface';
import { LooseObject, MonthYear } from '../common/common-type.interface';

import util from '../common/utility';

@Component({
    beforeRouteEnter(to: any, from: any, next: any) {
        next( (componentThis: any) => {
            if ( componentThis[componentThis.type] ) {
                componentThis.routeMeeting = componentThis[componentThis.type];

                componentThis.classes.length = 0;

                componentThis.addClass();

                componentThis.nextFormValidation(false);
            }
        });
    }
})
export default class extends Vue {
    /* router-view props */
    @Prop() public discipleshipCellMeeting: MinistryMeeting | any;
    @Prop() public otherMinistryMeeting: MinistryMeeting | any;

    /* Vue Route Props */
    @Prop() public type: string | undefined;
    @Prop() public title: string | undefined;

    public routeMeeting: LooseObject = {};
    public classes: LooseObject[] = [];

    @Prop() private month: any;
    @Prop() private year: any;

    public addClass() {
        this.classes.length = 0;

        this.routeMeeting.data.meetings.forEach((obj: LooseObject, key: any) => {
            const classes: LooseObject = {};

            for (const i in obj) {
                if (i !== 'id') {
                    classes[i] = { 'is-valid': false, 'is-invalid': true };
                }
            }

            this.classes.push(classes);
        });
    }

    public saveData(data: any) {
        util.eventBus.$emit('data', { type: this.type, data });
    }

    public addNewMeetingDetails() {
        this.routeMeeting.data.meetings.push({
            date: '',
            totalPeople: '',
            remarks: '',
            id: Date.now()
        });

        this.classes.push({
            date: {'is-valid': false, 'is-invalid': true},
            totalPeople: {'is-valid': false, 'is-invalid': true},
            remarks: {'is-valid': false, 'is-invalid': true}
        });

        this.saveData('new');
    }

    public removeMeetingDetails(index: number) {
        if (!this.routeMeeting) {
            return false;
        }

        this.routeMeeting.data.meetings.splice(index, 1);

        this.classes.splice(index, 1);

        this.saveData('removed index: ' + index);
    }

    public validateInput(event: Event, index: number, name: string) {
        const val = (event.target as HTMLFormElement).value.trim();

        let error = false;

        switch ( name ) {
            case 'date':
                error = util.isInvalidMonthYear(this.month, this.year, val);
                break;
            case 'remarks':
                error = val === '';
                break;
            case 'totalPeople':
                error = +val <=  0;
                break;
        }

        this.classes[index][name]['is-invalid'] = error;
        this.classes[index][name]['is-valid'] = !error;
    }

    public nextFormValidation(submitForm: boolean) {
        // 1 - Yes Validation
        let yesValid = true;

        this.routeMeeting.data.meetings.forEach( (v: any, i: number) => {
            for (const key in this.classes[i]) {
                if (this.classes[i].hasOwnProperty(key)) {
                    let error = false;

                    if ( key === 'totalPeople' ) {
                        error = v.totalPeople <= 0;
                    } else if (key === 'date') {
                        error = util.isInvalidMonthYear(this.month, this.year, v.date);
                    } else {
                        error = v[key].trim() === '';
                    }

                    this.classes[i][key]['is-invalid'] = error;
                    this.classes[i][key]['is-valid'] = !error;

                    if ( error ) {
                        yesValid = false;
                    }
                }
            }
        });

        // 2 - No Validation
        const noValid = this.routeMeeting.data.noMeetingRemarks.trim() !== '';

        // 3 - Section Validation
        this.routeMeeting.isValid = this.routeMeeting.data.hadMeeting === 'yes' ? yesValid : noValid;

        // 4 - Submit form if section is valid
        if (submitForm && this.routeMeeting.isValid) {
            const nextRoute = (this.type === 'discipleshipCellMeeting') ?
            'other-ministry-meetings' :
            'extra-activities';

            this.$router.push(nextRoute);
        }
    }

    get isInvalid() {
        let error = false;

        if ( this.routeMeeting.data.hadMeeting === 'yes' ) {
            this.classes.forEach((row: LooseObject, index: number) => {
                for ( const key in row ) {
                    if ( row.hasOwnProperty(key) && row[key]['is-invalid'] ) {
                        error = true;
                    }
                }
            });
        } else {
            error = this.routeMeeting.data.noMeetingRemarks.trim() === '';
        }

        this.routeMeeting.isValid = !error;

        return error;
    }

    get MonthYear(): MonthYear {
        return {
            month: this.month,
            year: this.year
        };
    }

    get minDate() {
        return this.year + '-' + util.addZero(this.month) + '-01';
    }

    get maxDate() {
        const maxDate = new Date(this.year, this.month, 0);

        return this.year + '-' + util.addZero((maxDate.getMonth() + 1)) + '-' + maxDate.getDate();
    }

    @Watch('MonthYear')
    private watchMonthYear(monthYear: MonthYear, oldValue: MonthYear) {
        if (oldValue && oldValue.month !== 0) {
            this.routeMeeting.data.meetings.forEach((meeting: MinistryMeetingInformation, index: number) => {
                const error = util.isInvalidMonthYear(this.month, this.year, meeting.date);

                this.classes[index].date['is-invalid'] = error;
                this.classes[index].date['is-valid'] = !error;

                if (error) {
                    this.routeMeeting.isValid = false;
                }
            });
        }
    }
}
